import { ID } from '@griply/types';

import { detachWrite } from '../detach-write';
import { FirestoreInstance } from '../types/firestore';
import { FirestoreCollections } from '../types/firestore-collections';

export type DeletePushTokenOptions<
  TDocRef = unknown,
  TDb = FirestoreInstance,
> = {
  token?: ID;
  installationId?: ID;
  db: TDb;
  doc: (db: NoInfer<TDb>, path: string, ...rest: string[]) => TDocRef;
  deleteDoc: (ref: NoInfer<TDocRef>) => Promise<void> | void;
  onWriteError: (error: unknown) => void;
};

export const deletePushToken = async <TDocRef, TDb = FirestoreInstance>({
  token,
  installationId,
  db,
  doc,
  deleteDoc,
  onWriteError,
}: DeletePushTokenOptions<TDocRef, TDb>): Promise<void> => {
  const docId = installationId ?? token;
  if (!docId) {
    return;
  }
  detachWrite(
    deleteDoc(doc(db, FirestoreCollections.FcmTokens, docId)),
    onWriteError,
  );
};
